// src/config.js
const SITE_CONFIG = {
  ASSISTANT: { ENABLED: true },
  SITE_ID: 's.hopkins.az',
  LISTING_PREVIEWS_ENABLED: true,
  BASE_URL: 'sandyhopkins.com',
  AMPLIFY_WEBHOOK: 'https://webhooks.amplify.us-east-1.amazonaws.com/prod/webhooks?id=f1a32514-857e-4c6d-820c-b2db26f8b6b0&token=g5sdopAO9d4xiGEJngEFj47qsz70Npz8ZSMMVw8&operation=startbuild',
  SENDER_EMAIL_ENCRYPTION_KEY: 'ddc32d25f6877ce7692b7361fe9c3cfa75c8fedc8ddbfb6529a636b950fd11bf',
  STATE: 'AZ',
  AGENT: {
    MLS_ID: '',
    NAME: 'Sandy Hopkins',
    BROKERAGE: "Maricopa Real Estate Company",
    EMAIL: 'maricopasandy@gmail.com',
    PHONE: '(520) 213-3096',
    ZILLOW_REVIEW: 'https://www.zillow.com/reviews/write/?s=X1-ZUzaq5sv4hktu1_5xifh',
    GOOGLE_REVIEW: '',
    BROKERAGE_LICENSE: 'b1df7dc05129e21e341be4d1e6d9fc09',
    BROKERAGE_NAME: 'Maricopa Real Estate Company',
    LICENSE: 'SA627284000'
  },
  LANDING_PAGE: {
    HERO_VIDEO: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/hopkins-landing-plain-004.mp4',
    WAVE_IMAGE: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/s.hopkins.wave.png',
    MARICOPA_APP: {
      ROUTE: '/maricopa-app/index.html',
      IOS_URL: 'https://apps.apple.com/us/app/community-clicker/id6444626976',
      ANDROID_URL: 'https://play.google.com/store/apps/details?id=com.ChamberMe.MACCMARICOPACC',
      QR_IMAGE: '/maricopa-community-app-qr.png'
    }
  },
  MLS: {
    NAME: 'Arizona Regional MLS',
    SHORT_NAME: 'ARMLS',
    LOGO_URL: 'https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/logos/s.hopkins.logo.png',
    DISCLAIMER: 'Based on information from Arizona Regional MLS. All data has not been verified and should be independently reviewed.'
  }
};


module.exports = { SITE_CONFIG };
